// extracted by mini-css-extract-plugin
export default {"block":"ServiceBlock_block__XukLO","dark":"ServiceBlock_dark__1LOO5","light":"ServiceBlock_light__MJb3B"};